import React, {useCallback, useEffect, useState} from 'react';

import {useDispatch, useSelector} from 'react-redux';
import {documentActions} from '../../../store/actions';
import {AccordionCard, DocumentDetails, FileViewer, SearchPanel} from '../components';
import Card from '../../../components/Card/CardBody';
import CardBody from '../../../components/Card/CardBody';
import PageHeader from '../../../components/PageHeader/PageHeader';
import Grid from '@mui/material/Grid';
import LoadingSpinner from "../../../components/Spinner/loading.spinner";
import {DOCUMENT_STATUS} from "../../../constants/DOCUMENT_STATUS";
import {DOCUMENT_VIEWER_MODES} from "../../../constants/DOCUMENT_VIEWER_MODES";
import FilterListIcon from "@mui/icons-material/FilterList";
import {VirtualRoom} from "./components";
import {makeStyles} from "@mui/styles";
import {EmptyList} from "../../../components/EmptyList";
import moment from "moment/moment";
import {history} from "../../../helpers/history";
import { SECURITY_ROLES } from '../../../constants/SECURITY_ROLES';
const VirtualDataRooms = (props) => {
  const {
    title = 'Virtual Data Rooms', subtitle = 'Available Virtual Data Rooms',
    initialSection = 'All Sections', includeSectionFilter = true,
    initialCompany = 'All Companies', includeCompanyFilter = false,
    initialClassification = 'All Media Types', includeClassificationFilter = true,
    initialCategory = 'All Categories', includeCategoryFilter = true,
    initialStatus = DOCUMENT_STATUS.APPROVED, includeStatusFilter = false,
    initialBeginDate= new moment().subtract(90, 'days'),
    includeBeginDate = true,
    initialEndDate = new moment(),
    includeEndDate = true,
    initialFilename = '', includeFilename = true,
    initialAttribute = '', includeAttribute = true,
    initialNbrOfDocuments = 5,
    sharedUserGuid = '',
    userGuid = '',
    viewer = DOCUMENT_VIEWER_MODES.LIST,
  } = props;


  const useStyles = makeStyles(theme => ({
    root: {
      padding: theme.spacing(0)
    },
    content: {
      marginTop: theme.spacing(1)
    },
    image: {
      position: 'absolute',
      left: 0,
      right: 0,
      top: 0,
      bottom: 0,
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      color: theme.palette.common.white,
    }
  }));

  const classes = useStyles();
  const dispatch = useDispatch();

  const filteredDocs = useSelector(state => state.documents.items);
  const {
    documents,
    categories,
    classifications,
    sections,
    companies
  } = filteredDocs ? filteredDocs : {};
  const {
    id,
    role,
    company,
    companyId,
    validatedCompanies
  } = useSelector(state => state.authentication.user);

  const isSharedUserRole = (role === SECURITY_ROLES.SHARED_USER);



  const [classificationSelect, setClassificationSelect] = useState(initialClassification);
  const [categorySelect, setCategorySelect] = useState(initialCategory);
  const [sectionSelect, setSectionSelect] = useState(initialSection);
  const [companySelect, setCompanySelect] = useState(initialCompany);
  const [statusSelect, setStatusSelect] = useState(initialStatus);
  const [beginDate, setBeginDate] = useState(initialBeginDate);
  const [endDate, setEndDate] = useState(initialEndDate);
  const [filename, setFilename] = useState(initialFilename);
  const [attribute, setAttribute] = useState(initialAttribute);

  const [statusList] = useState([
    DOCUMENT_STATUS.REJECTED,
    DOCUMENT_STATUS.REMOVED,
    DOCUMENT_STATUS.HOLD,
    DOCUMENT_STATUS.WAITING
  ]);

  const [initialLoad, setInitialLoad] = useState(true);
  const [isLoading, setLoading] = useState(false);
  const [files, setFiles] = useState([]);
  const [expanded, setExpanded] = useState(false);
  const [searchFields, setSearchFields] = useState({
    company_guid: companyId,
    company_selection: companySelect,
    user_guid: isSharedUserRole ? userGuid : id,
    section: sectionSelect,
    classification: classificationSelect,
    category: categorySelect,
    status: statusSelect,
    start_date: beginDate,
    end_date: endDate,
    file_name: filename,
    shared_user_guid: isSharedUserRole ? id : sharedUserGuid,
    role: role,
    by_vdr: true,
    documentsByMember: false,
    totalItemsToReturn: initialNbrOfDocuments,
    validatedCompanies: validatedCompanies
  });

  const handleCompanySelect = event => {
    setCompanySelect(event.target.value);
  };

  const handleCategorySelect = event => {
    setCategorySelect(event.target.value);
  };

  const handleClassificationSelect = event => {
    setClassificationSelect(event.target.value);
  };

  const handleSectionSelect = event => {
    setSectionSelect(event.target.value);
  };

  const handleBeginDateChange = date => {
    setBeginDate(date);
  };

  const handleEndDateChange = date => {
    setEndDate(date);
  };


  const handleRoomClick = room => {
    let pathname = '/documents';
    history.push({
      pathname: pathname,
      initialCompany: companySelect,
      initialSection: sectionSelect,
      initialClassification: classificationSelect,
      initialCategory: categorySelect,
      initialFilename: filename,
      initialAttribute: attribute,
      endDate: endDate,
      startDate: beginDate,
      sharedUser: true,
      sharedUserGuid: id,
      memberGuid: room.memberGuid,
      memberName: room.memberName,
      by_vdr: false,
      documentsByMember: true, // true: show documents by a member,  false = show documents by list of members
      validatedCompanies: validatedCompanies

    });
  };

  const handleFilenameChange = event => {
    setFilename(event.target.value);
  };

  const handleAttributeChange = event => {
    setAttribute(event.target.value);
  };

  const handleStatusSelect = event => {
    setStatusSelect(event.target.value);
  };

  const handleFilterClick = event => {
    searchDocWithFilters();

    setFilename('');
    setAttribute('');
  };

  function searchDocWithFilters() {
    setLoading(true);

    let searchDocumentFromDocumentServiceMethod = isSharedUserRole  ?
      searchFields => documentActions.searchSharedUserDocuments(searchFields) :
      searchFields => documentActions.searchDocuments(searchFields)

    const currentSearchFields = {
      ...searchFields,
      company_selection: companySelect,
      section: sectionSelect,
      classification: classificationSelect,
      category: categorySelect,
      start_date: beginDate,
      end_date: endDate,
      file_name: filename,
      attribute: attribute,
      by_vdr: true,   //  query by virtual data room
      documentsByMember: false, // true: show documents by a member,  false = show documents by list of members
      totalItemsToReturn: initialNbrOfDocuments
    }

    // Need to pass new filters to DocumentDetails.....
    setSearchFields(currentSearchFields);
    dispatch(searchDocumentFromDocumentServiceMethod(currentSearchFields));
    setLoading(false);
  }

  const searchDocWithFiltersCallback = useCallback(searchDocWithFilters,
      [isSharedUserRole, searchFields, companySelect, sectionSelect, classificationSelect, categorySelect, beginDate, endDate, filename, attribute, initialNbrOfDocuments, dispatch]);

  const filterCard =
      <Card
          plain
          style={{margin: 0, padding: 0}}
      >
        <CardBody style={{padding: 0}}>
          <Grid
              alignItems={'center'}
              container
              justifyContent={'center'}
              style={{padding: 0, margin: 0}}
          >
            <AccordionCard
                classes={classes}
                summaryText="Virtual Data Room Search Filters"
                company={company}
                role={role}
                expanded={expanded}
                setExpanded={setExpanded}

                initialSections={sections}
                initialCompanies={companies}
                initialCategories={categories}
                initialClassifications={classifications}
                initialStatus={statusList}

                sectionSelect={sectionSelect}
                companySelect={companySelect}
                categorySelect={categorySelect}
                classificationSelect={classificationSelect}
                statusSelect={statusSelect}

                beginDate={beginDate}
                filename={filename}
                endDate={endDate}
                attribute={attribute}

                onHandleSectionSelect={includeSectionFilter ? handleSectionSelect : undefined}
                onHandleCompanySelect={includeCompanyFilter ? handleCompanySelect : undefined}
                onHandleCategorySelect={includeCategoryFilter ? handleCategorySelect : undefined}
                onHandleClassificationSelect={includeClassificationFilter ? handleClassificationSelect : undefined}
                onHandleStatusSelect={includeStatusFilter ? handleStatusSelect : undefined}
                onHandleBeginDateSelect={includeBeginDate ? handleBeginDateChange : undefined}
                onHandleEndDateSelect={includeEndDate ? handleEndDateChange : undefined}
                onFilenameChange={includeFilename ? handleFilenameChange : undefined}
                onAttributeChange={includeAttribute ? handleAttributeChange : undefined}

                renderStatus="false"
                includeAllStatus="false"

                buttonText="Filter"
                buttonIcon={FilterListIcon}
                onButtonClick={handleFilterClick}
            />
          </Grid>
        </CardBody>
      </Card>

  useEffect(() => {
    if (initialLoad && companySelect) {
      searchDocWithFiltersCallback();
      setInitialLoad(false);
    }
  }, [dispatch, companySelect, filteredDocs, initialLoad, searchDocWithFiltersCallback]);

  return (
    <div className={classes.root}>
      <Card className={classes.content}>
        <PageHeader
          title={title} subTitle={subtitle}
        />
        {(!filteredDocs || !documents || initialLoad) ? (<LoadingSpinner/>) : (
            <Grid container justifyContent={"flex-start"}>
              {filterCard}
              {(documents.length > 0) ? (
                documents.map((app, index) => (
                  <Grid item xs={12} sm={12} md={6} lg={4} xl={3} key={index}>
                    <VirtualRoom
                      idx={index}
                      virtualRoom={documents[index]}
                      onRoomClick={handleRoomClick}
                    />
                  </Grid>
                  ))
                ) : (
                  <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                    <EmptyList
                      label="No Virtual Rooms to Display!"
                    />
                  </Grid>
                )}
            </Grid>
        )}
      </Card>
    </div>
  )
}

export default VirtualDataRooms
